import { render, staticRenderFns } from "./ConversationForm.vue?vue&type=template&id=60705318"
import script from "./ConversationForm.vue?vue&type=script&lang=js"
export * from "./ConversationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports